import React from "react";
import { Row, Col, Spin } from "antd";
import { FormInstance } from "antd/lib/form";
import { Employer, FormFieldConfig } from "../helpers/shared-interfaces";
import BaseForm from "../components/Form/BaseForm";
import moment from "moment";

export const GenerateStatementUI = (props: {
  reference: React.RefObject<FormInstance<any>>;
  url: string | undefined;
  employers?: Employer[];
}): JSX.Element => {
  const fields: FormFieldConfig[] = [
    {
      id: "startDate",
      name: "startDate",
      label: "Start Date",
      inputType: "defaultDate",
      placeholder: "Select Start Date",
      rule: "object",
      initialValue: moment("2012-01-01"),
      required: true,
      elementStyle: {
        width: "100%",
      },
      colConfig: {
        span: 24,
      },
    },
    {
      id: "endDate",
      name: "endDate",
      label: "End Date",
      inputType: "defaultDate",
      placeholder: "Select End Date",
      rule: "object",
      required: true,
      elementStyle: {
        width: "100%",
      },
      colConfig: {
        span: 24,
      },
    },
    {
      id: "companyId",
      name: "companyId",
      label: "Employers",
      inputType: "select",
      rule: "string",
      selectOptions: props.employers,
      placeholder: "Employers",
      required: true,
      colConfig: {
        span: 24,
      },
    },
  ];

  let fieldsToHide: string[] = [];
  if (!props.employers) {
    fieldsToHide = ["companyId"];
  }

  return (
    <>
      <Spin spinning={false}>
        <Row>
          <Col
            span={24}
            style={{
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                marginTop: "10px",
              }}
            >
              <BaseForm
                layout="vertical"
                reference={props.reference}
                fieldsToHide={fieldsToHide}
                fields={fields}
              ></BaseForm>
              {props.url && (
                <p>
                  <a href={props.url} target="_blank" rel="noopener noreferrer">
                    Download statement
                  </a>
                </p>
              )}
            </div>
          </Col>
        </Row>
      </Spin>
    </>
  );
};
